import { Smartphone, Monitor } from 'lucide-react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

export type DeviceMode = 'mobile' | 'desktop';

interface PreviewDeviceToggleProps {
  /** Current device mode */
  mode: DeviceMode;
  /** Callback when mode changes */
  onChange: (mode: DeviceMode) => void;
  /** Whether the toggle is disabled */
  disabled?: boolean;
}

/**
 * Toggle between mobile (320px) and desktop (480px) preview modes.
 */
export function PreviewDeviceToggle({ mode, onChange, disabled }: PreviewDeviceToggleProps) {
  return (
    <ToggleGroup
      type="single"
      value={mode}
      onValueChange={(value) => value && onChange(value as DeviceMode)}
      disabled={disabled}
      size="sm"
    >
      <ToggleGroupItem value="mobile" aria-label="Mobile Ansicht">
        <Smartphone className="h-4 w-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="desktop" aria-label="Desktop Ansicht">
        <Monitor className="h-4 w-4" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
